<div class="container-fluid">
  <app-loading *ngIf="cargando"></app-loading>

  <div class="grid" *ngIf="!cargando">
    <div class="col-12 md:col-4 lg:col-4" *ngIf="!detalle">
      <p-tree id="treeBien" [(value)]="treeProperties" selectionMode="checkbox"
              [(selection)]="nodeSelected"
               [loading]="loadingTree"
              (onNodeUnselect)="nodeUnselect($event)"
              (onNodeSelect)="nodeSelect($event)"
      >
        <ng-template let-item pTemplate="default">
          <span>{{ item.label }}</span>
        </ng-template>
      </p-tree>
    </div>
    <div [ngClass]="!detalle ? 'col-12 md:col-8 lg:col-8': 'col-12 md:col-12 lg:col-12'">
      <form [formGroup]="formularioActivos" novalidate id="fActivos"
            name="nomActivos">
      <p-table [columns]="columnas" [loading]="loadingTable" #dt
               [value]="getEvaluaciones" selectionMode="single" dataKey="idEvaluaciones"
               [paginator]="true" [rows]="10"  paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td class="table-break">{{row.codigoHojaEvaluacion}}</td>
            <td class="table-break">{{row.descripcionCuenta}}</td>
            <td class="table-break">{{row.cuentaContable}}</td>
            <td class="table-break" style="text-align: center"><p-checkbox binary="true"
                                                formControlName="indicadorAplicaTitular{{row.idCuentaContable}}"
                                                                           (onChange)="validarIndicadores('indicadorAplicaTitular', row, $event.checked)"></p-checkbox></td>
            <td class="table-break" style="text-align: center" ><p-checkbox binary="true"
                                                formControlName="indicadorAplicaCodeudor{{row.idCuentaContable}}"
                                                                           (onChange)="validarIndicadores('indicadorAplicaCodeudor', row, $event.checked)"></p-checkbox></td>
            <td class="table-break" style="text-align: center"><p-checkbox binary="true"
                                                formControlName="indicadorAplicaDeudorSolidario{{row.idCuentaContable}}"
                                                                           (onChange)="validarIndicadores('indicadorAplicaDeudorSolidario', row, $event.checked)"></p-checkbox></td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length" class="text-center">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
      </form>
    </div>
  </div>

  <div class="grid form-footer-buttons" *ngIf="!detalle">
    <div class="form-group col-12">
      <div *ngIf="!guardando">
        <a *ngIf="prodCuentaControlEditar" (click)="cancelarEdicion(formCuentaControl.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
        <button icon="fa fa-plus" label="{{tituloBoton | translate }}"
                type="submit"
                pButton (click)="guardarHojaEvalaacion()"></button>
      </div>
      <div *ngIf="guardando">
        <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
        <span>{{'LBL_GUARDANDO' | translate }}</span>
      </div>
    </div>
  </div>







</div>

<p-confirmDialog #cd key="producto-hoja-evaluacion">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
